"use client";

import translations from "@/lib/translations.json";
import { Button } from "@/components/ui/button";
import { ArrowRight, Cloud, Shield, Zap } from "lucide-react";
import { useRouter } from "next/navigation";
import { useWebsiteLang } from "../context/website-lang-context";

const icons = [Shield, Cloud, Zap];

export default function FinalCTA() {
  const router = useRouter();
  const { lang } = useWebsiteLang();
  const t = translations[lang].website.finalCta;

  const handleCTAClick = () => {
    router.push("/coming-soon");
  };

  return (
    <section id="pricing" className="relative overflow-hidden py-20 sm:py-28">
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-900/50 to-navy-950" />

      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="group relative overflow-hidden rounded-3xl border border-amber-500/20 p-8 text-center glow-amber glass-strong sm:p-12 lg:p-16">
          <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_top,rgba(249,115,22,0.25),transparent_55%)]" />

          <div className="relative z-10 mb-6 inline-flex items-center gap-2 rounded-full border border-amber-500/20 px-4 py-1.5 text-xs font-medium text-amber-400 glass">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse-slow" />
            {t.badge}
          </div>
          <h2 className="relative z-10 mb-5 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            {t.titlePrefix}{" "}
            <span className="text-gradient-amber">{t.titleHighlight}</span>
          </h2>
          <p className="relative z-10 mx-auto mb-8 max-w-2xl text-lg leading-relaxed text-white/50">
            {t.description}
          </p>

          <Button
            onClick={handleCTAClick}
            size="custom"
            className="group relative z-10 mb-8 inline-flex items-center justify-center gap-2 rounded-lg bg-amber-500 px-7 py-3.5 text-lg font-semibold text-blue-950 transition-all duration-200 hover:bg-amber-400 hover:shadow-lg hover:shadow-amber-500/25"
          >
            {t.cta}
            <ArrowRight
              size={18}
              className="transition-transform group-hover:translate-x-0.5"
            />
          </Button>

          <div className="relative z-10 flex flex-wrap items-center justify-center gap-6">
            {t.trustItems.map((item, index) => {
              const Icon = icons[index] ?? Shield;
              return (
                <div
                  key={item}
                  className="flex items-center gap-2 text-sm text-white/40"
                >
                  <Icon size={16} className="text-amber-500/60" />
                  {item}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
